import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import Image from '../../../../../shared/components/Image';
import { generateNumberFromString } from '../../../../../shared/utils/NumberUtils';

export default class HeaderThumbnail extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        thumbnailImageUrl: PropTypes.string,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    };

    _generateNumberFromId = () => generateNumberFromString(this.props.id, 13);

    getDefaultThumbnail = (name, className) => (
        <div
            className={cns(
                'header-thumbnail',
                'default-thumbnail',
                `avatar-color-${this._generateNumberFromId()}`,
                className
            )}
        >
            <span>{name && name.slice(0, 2).toUpperCase()}</span>
        </div>
    );

    render() {
        const { name = '', className, thumbnailImageUrl } = this.props;
        if (thumbnailImageUrl) {
            return (
                <Image
                    className={cns('header-thumbnail', className)}
                    src={thumbnailImageUrl}
                    dimension={{ w: 240, h: 240 }}
                    cloudinaryCrop={'fill'}
                />
            );
        }
        return this.getDefaultThumbnail(name, className);
    }
}
